module.exports = __webpack_public_path__ + "img/love-active.b35cf051.svg";